<template>
	<div class="form-sidebar">
		<v-container class="form-sidebar-container grid-list-lg">
			<slot></slot>
		</v-container>
	</div>
</template>

<script>
export default {
	name: 'form-sidebar',
};
</script>

<style lang="scss" scoped>
.form-sidebar {
	padding: 16px 20px;
}
.form-sidebar-container {
	background: white;
	border: 1px solid #e0e7ee;
	border-radius: 12px;
	box-shadow: 0 5px 18px rgba(31, 55, 78, .06);
	padding: 18px !important;
}
@media (max-width: 700px) {
	.form-sidebar { padding: 10px; }
	.form-sidebar-container { border-radius: 10px; padding: 13px !important; }
}
</style>

<style lang="scss">
.form-sidebar {
	@include form-fields;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/form-sidebar.vue